export const corporate = {
  red: '#DD0C29',
  blue: '#162031',
  grey: '#A8AFBA'
};
